import { VendorBusinessDetailsEmptyState } from '../../../PaymentDetails/BusinessDetails/VendorEmptyState'
import { useState } from 'react'
import { AddBusinessDetails } from './AddBusinessDetails'
import { RowLayout } from '../../Vendors/VendorCreation/General/VendorForm/RowLayout'
import {
  SETTINGS_STATUSES_CLASSNAME,
  SETTINGS_STATUSES_NAME,
  SETTINGS_STATUSES_TOOLTIP
} from '../../../../pages/Settings/constants'
import { Status } from '../../../../components/Status'
import { FieldWithLabel } from '../../../../components/FieldWithLabel/FieldWithLabel'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'

export const BankingSetup = ({ businessDetails, getBusinessDetails }) => {
  const [isPopupVisible, setPopupVisible] = useState<boolean>(false)

  const handleOpen = () => setPopupVisible(true)
  return (
    <>
      {!businessDetails.uuid ? (
        <VendorBusinessDetailsEmptyState onClick={handleOpen} />
      ) : (
        <div className="business-details-container">
          <RowLayout title="Status">
            <div className="mt-12">
              {businessDetails.verification_status && (
                <Tooltip
                  title={
                    SETTINGS_STATUSES_TOOLTIP[
                      businessDetails.verification_status
                    ]
                  }
                  placement="topLeft"
                >
                  <div>
                    <Status.Default
                      className={
                        SETTINGS_STATUSES_CLASSNAME[
                          businessDetails.verification_status
                        ]
                      }
                    >
                      {
                        SETTINGS_STATUSES_NAME[
                          businessDetails.verification_status
                        ]
                      }
                    </Status.Default>
                  </div>
                </Tooltip>
              )}
            </div>
          </RowLayout>
          <div className="separator mb-32 mt-32" />
          <RowLayout title="Business information">
            <div className="mt-12">
              <FieldWithLabel title="Legal business name">
                {businessDetails.legal_business_name}
              </FieldWithLabel>
            </div>
          </RowLayout>
        </div>
      )}
      <AddBusinessDetails
        isPopupVisible={isPopupVisible}
        getDetails={getBusinessDetails}
        setIsPopupVisible={setPopupVisible}
      />
    </>
  )
}
